import * as DialogPrimitive from '@radix-ui/react-dialog';

import { useSidebarStore } from '@/lib/store/sidebarStore';
import { cn } from '@/lib/utils/cn';

import { Sidebar } from './Sidebar';

export function MobileSidebarDrawer() {
    const open = useSidebarStore((state) => state.mobileOpen);
    const setOpen = useSidebarStore((state) => state.setMobileOpen);

    return (
        <DialogPrimitive.Root open={open} onOpenChange={setOpen}>
            <DialogPrimitive.Portal>
                <DialogPrimitive.Overlay className="fixed inset-0 z-40 bg-foreground/30 backdrop-blur-[2px] data-[state=open]:animate-fade-in lg:hidden" />
                <DialogPrimitive.Content
                    className={cn(
                        'fixed inset-y-0 left-0 z-50 w-72 max-w-[85vw] border-r border-border bg-background shadow-md',
                        'data-[state=open]:animate-slide-in-right data-[state=closed]:animate-slide-out-right',
                        'lg:hidden',
                    )}
                >
                    <DialogPrimitive.Title className="sr-only">Navigation</DialogPrimitive.Title>
                    <Sidebar onNavigate={() => setOpen(false)} />
                </DialogPrimitive.Content>
            </DialogPrimitive.Portal>
        </DialogPrimitive.Root>
    );
}
